<template>
  <a-modal v-model="modal" title="新建" width="500px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
          :rules="rules.organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
            @change="inventOrgValueOnChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="车间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workshopCode"
          :rules="rules.workshopCode"
        >
          <global-select
            :value.sync="formData.workshopCode"
            :selectData="workshopList"
            selectType="selectAssembleFilter"
            :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="业务类型"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="businessType"
          :rules="rules.businessType"
        >
          <global-select
            :value.sync="formData.businessType"
            :selectData="businessTypeList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="生产提前期"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="produceLeadTime"
          :rules="rules.produceLeadTime"
        >
          <a-input-number v-model="formData.produceLeadTime" style="width: 100%" :precision="0"/>
        </a-form-model-item>
        <a-form-model-item
          label="业务简称"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="businessShortName"
          :rules="rules.businessShortName"
        >
          <a-input v-model="formData.businessShortName" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="是否揉单"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="mixOrderFlag"
          :rules="rules.mixOrderFlag"
        >
          <a-select v-model="formData.mixOrderFlag" placeholder="请选择">
            <a-select-option value="Y">是</a-select-option>
            <a-select-option value="N">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="揉单天数"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="mixOrderNum"
        >
          <a-input-number v-model="formData.mixOrderNum" style="width: 100%" :precision="0" :min="1"/>
        </a-form-model-item>
        <a-form-model-item
          label="是否合并叫料"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="combineCallRequestFlag"
          :rules="rules.combineCallRequestFlag"
        >
          <a-select v-model="formData.combineCallRequestFlag" placeholder="请选择">
            <a-select-option value="Y">是</a-select-option>
            <a-select-option value="N">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="是否联动车位计划时间"
          :labelCol="{ style: 'width: 150px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 150px ) !important;float:left'}"
          prop="linkTimeFlag"
        >
          <a-select v-model="formData.linkTimeFlag" allow-clear placeholder="请选择">
            <a-select-option value="Y">是</a-select-option>
            <a-select-option value="N">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="供应类型"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="supplyType"
          :rules="rules.supplyType"
        >
          <global-select
            :value.sync="formData.supplyType"
            :selectData="supplyTypeList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="供应子库"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="supplySublibrary"
          :rules="rules.supplySublibrary"
        >
          <global-select
            searchParam="warehouseCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.supplySublibrary"
            requestApi="/inv/invCallRequestLines/intoSublibraryBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'organizationCode': formData.organizationCode }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="完工子库"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="completedSublibrary"
          :rules="rules.completedSublibrary"
        >
          <global-select
            searchParam="warehouseCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.completedSublibrary"
            requestApi="/inv/invCallRequestLines/intoSublibraryBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'organizationCode': formData.organizationCode }"
            @change="handleCompletedSublibraryChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="完工货位"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="completedLocation"
          :rules="rules.completedLocation"
        >
          <global-select
            searchParam="locationCode"
            selectType="selectSearch"
            :value.sync="formData.completedLocation"
            requestApi="/inv/invCallRequestLines/intoGoodsAllocationBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'subinventoryCode': formData.completedSublibrary }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList, apiBomProductionScheduleAttributeCcAdd } from '@/api/mes/productionPrepare/attributeMaintenance'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.cacheLookupRequest('MES_MO_CC_TYPE', { lookupType: 'MES_MO_CC_TYPE', current: 1, pageSize: 999 }, 'businessTypeList')
    this.cacheLookupRequest('MES_SUPPLY_TYPE', { lookupType: 'MES_SUPPLY_TYPE', current: 1, pageSize: 999, attribute2: 1 }, 'supplyTypeList')
  },
  data() {
    return {
      modal: false,
      formData: {
        organizationCode: '', //  组织
        workshopCode: '', //  所属车间
        businessType: '', // 业务类型
        produceLeadTime: '', // 生产提前期
        businessShortName: '', // 业务简称
        mixOrderFlag: 'N', // 是否揉单
        mixOrderNum: '', // 揉单天数
        combineCallRequestFlag: 'N', // 是否合并叫料
        linkTimeFlag: '', // 是否联动车位计划时间
        supplyType: '', // 供应类型
        supplySublibrary: '', // 供应子库
        completedSublibrary: '', // 完工子库
        completedLocation: '' // 完工库位
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        workshopCode: [{ required: true, message: ' ', trigger: 'change' }],
        businessType: [{ required: true, message: ' ', trigger: 'change' }],
        produceLeadTime: [{ required: true, message: ' ', trigger: 'change' }],
        businessShortName: [{ required: true, message: ' ', trigger: 'change' }],
        mixOrderFlag: [{ required: true, message: ' ', trigger: 'change' }],
        combineCallRequestFlag: [{ required: true, message: ' ', trigger: 'change' }],
        supplyType: [{ required: true, message: ' ', trigger: 'change' }],
        supplySublibrary: [{ required: true, message: ' ', trigger: 'change' }],
        completedSublibrary: [{ required: true, message: ' ', trigger: 'change' }],
        completedLocation: [{ required: true, message: ' ', trigger: 'change' }]
      },
      businessTypeList: [], // 业务类型列表
      supplyTypeList: [], // 供应类型列表
      workshopList: [] // 车间列表
    }
  },
  methods: {
    // 子库变化
    handleCompletedSublibraryChange() {
      this.formData.completedLocation = ''; // 变化完工子库时，清空完工库位
    },
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'workshopCode', '')
      this.$set(this.formData, 'businessType', '')
      this.$set(this.formData, 'produceLeadTime', '')
      this.$set(this.formData, 'businessShortName', '')
      this.$set(this.formData, 'mixOrderFlag', 'N')
      this.$set(this.formData, 'mixOrderNum', '')
      this.$set(this.formData, 'combineCallRequestFlag', 'N')
      this.$set(this.formData, 'linkTimeFlag', '')
      this.$set(this.formData, 'supplyType', '')
      this.$set(this.formData, 'supplySublibrary', '')
      this.$set(this.formData, 'completedSublibrary', '')
      this.$set(this.formData, 'completedLocation', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiBomProductionScheduleAttributeCcAdd(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.formData.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
